var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-block"},[(_vm.title || _vm.$slots.title)?_c('SectionTitle',_vm._g(_vm._b({attrs:{"title":_vm.title}},'SectionTitle',_vm.$attrs,false),_vm.$listeners),[_vm._t("title")],2):_vm._e(),_c('div',{class:{ 'mt-[24px]': _vm.title || _vm.$slots.title }},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }